module.exports = {
      id: "menu-search-usage",
      viewBox: "0 0 28.943 16.863",
      url: "/" + "sprite-84df178c245af8be09420a4d0455d997.svg#menu-search",
      toString: function () {
        return this.url;
      }
    }